import { SmartSendItemApiModel, Meta, Product, MarketplaceOrderApiModel } from '~/lib/api/smartsend/types';
import { SmartSendProvider } from '~/lib/consts/providers';

export function createNewSmartSendItem(defaultCountry: string): SmartSendItemApiModel {
  return {
    Recipient: {
      CountryIsoCode: defaultCountry,
      CountrySubdivision: null,
      Name: '',
      Postcode: '',
      Email: '',
      Phone: '',
      Town: '',
      AddressLine1: '',
      AddressLine2: '',
      Provider: SmartSendProvider,
      Meta: {}
    },
    MarketplaceOrderLines: [
      {
        MarketplaceOrderId: '',
        Value: 20,
        Meta: {} as Meta,
        Product: {
          Sku: '',
          Meta: {}
        } as Product
      } as MarketplaceOrderApiModel
    ],
    Value: 20,
    Description: '',
    Status: 'Active',
    MarketplaceStatus: 'Sold',
    Created: new Date(),
    PackageDimensions: { Weight: 1, Height: 10, Width: 10, Length: 10 },
    Owners: [],
    Tags: [],
    Extras: [],
    Meta: {}
  } as SmartSendItemApiModel;
}
